<template>
	<div>
		<div class="card mb-4">
	        <div class="card-header">
				<div class="d-flex justify-content-between container-fluid">
		            <div class="text-muted fs-19">
		            	<strong>Pagamentos</strong>
		            </div>
                    <button
						class="btn btn-success"
						v-show="!dados.pago && dados.valor > 0"
						@click="pagar">
						<i class="fas fa-money-check-alt mr-2"></i>
						Efetuar Pagamento
					</button>
			    </div>
		    </div>
		    <div class="card-body">
                <pedido-pagamento-table
		        	@update="update"
                    @destroy="destroy">
		        </pedido-pagamento-table>
		    </div>
		</div>
		<!-- Update pagamento -->
		<receita-update
			:dado_id="dado_id"
			@reload="reload">
		</receita-update>
		<!-- Delete pagamento -->
		<bsh-confirm
        	modal_id="confirm_destroy_receita"
        	:dado_id="dado_id"
        	title="Deseja realmente cancelar este pagamento?"
        	btn="Excluir"
        	btnStyle="btn-danger"
        	method="delete"
        	:rota="$url+'/api/adm/receita/destroy/'"
        	@reload="reload">
        </bsh-confirm>
	</div>
</template>

<script>
	export default {
        props: ['dados'],
        data(){
            return {
                dado_id: null
            }
        },
		methods: {
			update(id){
				this.dado_id = id;
				$('#update_receita').modal('show');
			},
			destroy(id){
				this.dado_id = id;
				$('#confirm_destroy_receita').modal('show');
			},
            pagar(){
                this.$emit('pagar')
            },
			reload(){
				this.$emit('reload')
			}
		}
	}
</script>
